/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const Return: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M4.62821 8.51923L7.07051 6.08974L5.98718 5L2.26923 8.70513C2.25641 8.71795 2.24103 8.73077 2.22436 8.74359C2.1859 8.78205 2.15385 8.82308 2.12821 8.86538L2 9.28846L2.12821 9.71154C2.15385 9.75385 2.1859 9.79487 2.22436 9.83333L5.98077 13.5897L7.07051 12.5L4.62821 10.0577H16.8077C17.8115 10.0577 18.6705 10.4141 19.3846 11.1282H19.391C20.1051 11.8423 20.4615 12.7026 20.4615 13.7115C20.4615 14.7205 20.1051 15.5808 19.391 16.2949H19.3846C18.6705 17.009 17.8115 17.3654 16.8077 17.3654H13.7949V18.9038H16.8077C18.2397 18.9038 19.4615 18.3974 20.4744 17.3846C21.491 16.3718 22 15.1474 22 13.7115C22 12.2756 21.491 11.0513 20.4744 10.0385C19.4615 9.02564 18.2397 8.51923 16.8077 8.51923H4.62821V8.51923Z" />

    </StyledIconBase>
  )
})

Return.displayName = 'Return'

export const ReturnDimensions = {height: 24, width: 24}
